import { CaretDownIcon } from '@tovala/component-library'

import StarSharpIcon from 'components/common/icons/StarSharpIcon'

const MealDetailsAverageRating = ({
  onClick,
  stars,
}: {
  onClick: () => void
  stars: number
}) => {
  const formattedStars = stars.toFixed(1)

  return (
    <button
      className="inline-flex items-center gap-x-1.5 text-k/20_110"
      onClick={onClick}
      type="button"
    >
      <span aria-hidden="true" className="block h-4 w-4 text-orange-1">
        <StarSharpIcon />
      </span>

      <span aria-hidden="true">{formattedStars}</span>

      <span aria-hidden="true" className="block h-4 w-4 text-grey-9">
        <CaretDownIcon />
      </span>

      <span className="sr-only">
        Average rating: {formattedStars} out of 5 stars. See reviews
      </span>
    </button>
  )
}

export default MealDetailsAverageRating
